// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-lg_banner__rb8zu"};